import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { User } from '../../__generated__/graphql';
import { useCallback } from 'react';

export const useUsersList = () => {
  const { data } = useQuery(
    graphql(`
        query usersList {
            users {
                id
                schedulable
                name
                image
                title
                doctor
                brands
                schedulableServices
                schedulableClinics
                color
                __typename
                pinSet
            }
        }
    `),
    { fetchPolicy: 'cache-first' },
  );

  const users = [...(data?.users ?? [])].sort(
    // @ts-ignore
    (a: User, b: User) => a?.name?.localeCompare(b.name ?? '') ?? 0,
  ) as User[];

  const findUser = useCallback((userID: string): User | null => {
    return data?.users?.find(a => a?.id === userID) ?? null;
  }, [data?.users]);

  return { users, findUser };
};
